import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'react-feather';
import Skeleton from 'react-loading-skeleton';
import { Utils } from '../../../../utils';
import { nextPage, previousPage } from "../../../../utils/pagination";
import DossierDetail from '../../components/DossierDetail';
import FiltreDossier from '../../components/FilterDossier';

const dossiersMock = [
  {
    id: 'DOS-001',
    type: 'Personne Physique',
    nomClient: 'Jean Dupont',
    dateCreation: '12/04/2023',
    statut: 'En cours',
    juridiction: 'Abidjan',
    etape: 'Vérification des documents'
  },
  {
    id: 'DOS-002',
    type: 'Personne Morale',
    nomClient: 'Tech Solutions SARL',
    dateCreation: '18/04/2023',
    statut: 'En attente',
    juridiction: 'San Pedro',
    etape: 'Paiement'
  },
  {
    id: 'DOS-003',
    type: 'Personne Physique',
    nomClient: 'Marie Konan',
    dateCreation: '22/04/2023',
    statut: 'Complété',
    juridiction: 'Bouaké',
    etape: 'Dossier transmis'
  },
  {
    id: 'DOS-004',
    type: 'Personne Morale',
    nomClient: 'Ivoire Construction SA',
    dateCreation: '25/04/2023',
    statut: 'En cours',
    juridiction: 'Abidjan',
    etape: 'Examen juridique'
  },
  {
    id: 'DOS-005',
    type: 'Personne Physique',
    nomClient: 'Paul Kouamé',
    dateCreation: '28/04/2023',
    statut: 'En attente',
    juridiction: 'Daloa',
    etape: 'Documents manquants'
  },
];

const DossiersList = () => {
  const [allDossiers, setAllDossiers] = useState({ results: dossiersMock, count: dossiersMock.length, next: null, previous: null });
  const [dossiers, setDossiers] = useState(dossiersMock);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const ELEMENT_PER_PAGE = 20;


  const [selectedDossier, setSelectedDossier] = useState(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    statut: '',
    type: '',
    juridiction: ''
  });

  const fetchDossiers = useCallback(async () => {
    setLoading(true);
    setIsSearching(false);

    try {
      // Simuler une API fetch avec les données fictives
      setTimeout(() => {
        setAllDossiers({
          results: dossiersMock,
          count: dossiersMock.length,
          next: null,
          previous: null
        });
        setDossiers(dossiersMock);

        const PAGE_NUMBER = Math.ceil(dossiersMock.length / ELEMENT_PER_PAGE);
        setTotalPage(PAGE_NUMBER);
        setLoading(false);
      }, 500);
    } catch (error) {
      console.error("Error fetching dossiers:", error);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDossiers();
  }, [fetchDossiers]);

  // Nouvelle fonction pour appliquer les filtres
  const applyFilters = (filters) => {
    setLoading(true);
    setActiveFilters(filters);

    setTimeout(() => {
      let filteredResults = [...dossiersMock];

      // Filtrer par statut si sélectionné
      if (filters.statut) {
        filteredResults = filteredResults.filter(dossier =>
          dossier.statut === filters.statut
        );
      }

      // Filtrer par type si sélectionné
      if (filters.type) {
        filteredResults = filteredResults.filter(dossier =>
          dossier.type === filters.type
        );
      }

      // Filtrer par juridiction si sélectionnée
      if (filters.juridiction) {
        filteredResults = filteredResults.filter(dossier =>
          dossier.juridiction === filters.juridiction
        );
      }

      setDossiers(filteredResults);
      setLoading(false);
    }, 500);
  };

  const handleNextPage = async (params) => {
    setLoading(true);
    if (params) {
      // Simulation pagination
      setTimeout(() => {
        setPage(prevPage => prevPage + 1);
        setLoading(false);
      }, 300);
    }
    setLoading(false);
  };

  const handlePreviousPage = async (params) => {
    setLoading(true);
    if (params) {
      // Simulation pagination
      setTimeout(() => {
        page > 0 ? setPage(page - 1) : setPage(1);
        setLoading(false);
      }, 300);
    }
    setLoading(false);
  };

  const handleSearch = async () => {
    if (searchTerm.trim() !== "") {
      setLoading(true);
      setIsSearching(true);

      try {
        // Simulation d'une recherche
        setTimeout(() => {
          const filteredResults = dossiersMock.filter(dossier =>
            dossier.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
            dossier.nomClient.toLowerCase().includes(searchTerm.toLowerCase())
          );
          setDossiers(filteredResults);
          setLoading(false);
        }, 500);
      } catch (error) {
        console.error("Erreur lors de la recherche :", error);
        setLoading(false);
      }
    } else {
      setDossiers(allDossiers.results);
      setIsSearching(false);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      // Simulation d'un changement de statut
      setDossiers((prevDossiers) =>
        prevDossiers.map((dossier) =>
          dossier.id === id ? { ...dossier, statut: currentStatus === 'En cours' ? 'Complété' : 'En cours' } : dossier
        )
      );
    } catch (error) {
      console.error("Erreur réseau :", error);
      alert("Impossible de mettre à jour le statut de ce dossier.");
    }
  };

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  // Fonction pour ouvrir le détail d'un dossier
  const handleOpenDetail = (dossier) => {
    setSelectedDossier(dossier);
    setIsDetailOpen(true);
  };

  // Fonction pour fermer le détail
  const handleCloseDetail = () => {
    setIsDetailOpen(false);
    setTimeout(() => setSelectedDossier(null), 300);
  };

  // Fonction pour ouvrir le modal de filtrage
  const handleOpenFilterModal = () => {
    setIsFilterModalOpen(true);
  };

  // Fonction pour fermer le modal de filtrage
  const handleCloseFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center my-4">
        <div className="flex items-center gap-2">
          <input
            type="text"
            className="input w-48 p-2 text-black rounded-lg focus:ring-2 focus:ring-theme-1 placeholder-gray-500"
            placeholder="Rechercher par ID ou Client"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-700"
            onClick={handleSearch}
          >
            Rechercher
          </button>
          {/* Bouton pour ouvrir le modal de filtrage */}
          <button
            className="bg-orange-500 text-white p-2 rounded-lg hover:bg-orange-600 flex items-center justify-center"
            onClick={handleOpenFilterModal}
            title="Filtrer les dossiers"
          >
            <Icons.Filter size={20} />
          </button>
        </div>

        {/* Indicateur de filtres actifs */}
        {(activeFilters.statut || activeFilters.type || activeFilters.juridiction) && (
          <div className="flex items-center text-sm text-gray-600">
            <Icons.Check size={16} className="mr-1 text-green-500" />
            <span>Filtres actifs</span>
          </div>
        )}
      </div>

      <div className="overflow-auto mb-10">
        <table className="table-auto w-full text-gray-700 table table-report sm:mt-2">
          <thead>
            <tr className="bg-transparent text-black">
              <th>ID</th>
              <th>Type</th>
              <th>Client</th>
              <th>Date création</th>
              <th>Statut</th>
              <th>Juridiction</th>
              <th>Étape actuelle</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8">
                  <Skeleton count={5} />
                </td>
              </tr>
            ) : (
              dossiers.map((dossier) => (
                <tr key={dossier.id} className="bg-white rounded-lg">
                  <td className="font-medium">{dossier.id}</td>
                  <td>{dossier.type}</td>
                  <td>{dossier.nomClient}</td>
                  <td>{dossier.dateCreation}</td>
                  <td className={
                    dossier.statut === 'En cours'
                      ? 'text-blue-500'
                      : dossier.statut === 'Complété'
                        ? 'text-green-500'
                        : 'text-yellow-500'
                  }>
                    {dossier.statut}
                  </td>
                  <td>{dossier.juridiction}</td>
                  <td>{dossier.etape}</td>
                  <td>
                    <div className="flex space-x-2">
                      <div className="relative inline-block">
                        <button
                          className="bg-gray-500 text-white px-2 py-1 rounded flex items-center"
                          onClick={() => handleOpenDetail(dossier)}
                        >
                          <Icons.Eye className="mr-1" />
                          Voir
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div
          className={
            !isSearching && allDossiers.count > 20
              ? "px-5 py-3 flex justify-end text-right border-t border-gray-200"
              : "hidden"
          }
        >
          <button
            onClick={() => handlePreviousPage(allDossiers.previous)}
            type="button"
            className="button flex w-36 items-center border bg-theme-1 text-white"
          >
            <span>
              <Icons.ArrowLeft />
            </span>
            <span> Précédent </span>
          </button>
          <div className="bg-white text-gray-600 bold mx-5 p-3 box">
            {dossiers
              ? (
                <span>
                  {page} / {totalPage}
                </span>
              ) : (
                0
              )}
          </div>
          <button
            onClick={() => handleNextPage(allDossiers.next)}
            type="button"
            className="button flex w-36 items-center border bg-theme-1 text-white"
          >
            <span> Suivant </span>
            <span>
              <Icons.ArrowRight />
            </span>
          </button>
        </div>
      </div>

      {/* Composant de détail du dossier */}
      <DossierDetail
        dossier={selectedDossier}
        isOpen={isDetailOpen}
        onClose={handleCloseDetail}
      />

      {/* Composant de filtrage */}
      <FiltreDossier
        isOpen={isFilterModalOpen}
        onClose={handleCloseFilterModal}
        onApplyFilters={applyFilters}
      />
    </div>
  );
};

export default DossiersList;